export default __webpack_public_path__ + "media/meal-feedback.ba362f63d69d4729138b25382b16b208.webp";